import { render, staticRenderFns } from "./companion-list.vue?vue&type=template&id=3d409a04&scoped=true&"
import script from "./companion-list.vue?vue&type=script&lang=js&"
export * from "./companion-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d409a04",
  null
  
)

export default component.exports